<template>
    <div class="demo-container">
        <div class="demo-top">
            <div class="demo-top-card">
                <div class="demo-top-card-top">
                    <div>
                        <div class="demo-top-card-title">应收余额</div>
                        <div>
                            <span class="demo-top-card-money">135.00</span>
                            <span>亿元</span>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/ysye.png" alt="" />
                    </div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">期初&nbsp;122.00&nbsp;亿元</div>
                    <div>环比&nbsp;11%&nbsp;<span class="to-bottom"></span></div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">同期&nbsp;122.00&nbsp;亿元</div>
                    <div>同比&nbsp;31%&nbsp;<span class="to-top"></span></div>
                </div>
            </div>
            <div class="demo-top-card">
                <div class="demo-top-card-top">
                    <div>
                        <div class="demo-top-card-title">逾期总额</div>
                        <div>
                            <span class="demo-top-card-money">35.00</span>
                            <span>亿元</span>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/yqze.png" alt="" />
                    </div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">期初&nbsp;29.00&nbsp;亿元</div>
                    <div>环比&nbsp;21%&nbsp;<span class="to-bottom"></span></div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">同期&nbsp;32.00&nbsp;亿元</div>
                    <div>同比&nbsp;32%&nbsp;<span class="to-top"></span></div>
                </div>
            </div>
            <div class="demo-top-card">
                <div class="demo-top-card-top">
                    <div>
                        <div class="demo-top-card-title">DSO</div>
                        <div>
                            <span class="demo-top-card-money">78.00</span>
                            <span>亿元</span>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/dso.png" alt="" />
                    </div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">期初&nbsp;76.00&nbsp;亿元</div>
                    <div>环比&nbsp;3%&nbsp;<span class="to-bottom"></span></div>
                </div>
                <div class="demo-top-card-center">
                    <div class="demo-top-card-center-left">同期&nbsp;64.00&nbsp;亿元</div>
                    <div>同比&nbsp;33%&nbsp;<span class="to-top"></span></div>
                </div>
            </div>
        </div>
        <div class="demo-center">
            <div class="demo-center-left">
                <div class="demo-center-title">账龄分布</div>
                <div class="demo-center-left-chart">
                    <div id="barOne" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
            <div class="demo-center-right">
                <div class="demo-center-title">组织占比</div>
                <div class="demo-center-left-chart">
                    <div id="pieOne" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
        </div>
        <div class="demo-center">
            <div class="demo-center-left">
                <div class="demo-center-title">新增逾期趋势</div>
                <div class="demo-center-left-chart">
                    <div id="barTwo" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
            <div class="demo-center-right">
                <div class="demo-center-title">坏账金额</div>
                <div class="demo-center-left-chart">
                    <div id="pieTwo" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
        </div>
        <div class="demo-center">
            <div class="demo-center-left">
                <div class="demo-center-title">应收变化</div>
                <div class="demo-center-left-chart">
                    <div id="barThree" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
            <div class="demo-center-right">
                <div class="demo-center-title">逾期客户占比</div>
                <div class="demo-center-left-chart">
                    <div id="pieThree" :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup name="DemoCharts">
import { onMounted } from 'vue';
import * as echarts from 'echarts'

const barOneOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        top: '0%',
        right: '1%',
        bottom: '5%',
    },
    grid: {
        top: '22%',
        left: '0.5%',
        right: '2%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['0-30天', '30-60天', '60-90天', '90-120天', '120-150天', '150-180天', '180-360天', '360-720天', '>720天']
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '单位（天）'
        }
    ],
    series: [
        {
            name: '应收',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
                focus: 'series'
            },
            barWidth: '22',
            data: [20, 32, 10, 34, 90, 60, 70, 80, 65]
        },
        {
            name: '逾期',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
                focus: 'series'
            },
            barWidth: '22',
            data: [22, 18, 91, 34, 29, 33, 10, 23, 10]
        },
    ]
};

const pieOneOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        bottom: '-1%',
        left: '22%',
        data: ['苏宁', '五星','超市','联盟','直营','其他']
    },
    series: [
        {
            name: '组织占比',
            type: 'pie',
            radius: ['50%', '65%'],
            center: ['51%', '43%'],
            itemStyle: {
                borderRadius: 4,
                borderColor: '#fff',
                borderWidth: 2
            },
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center',
            },
            emphasis: {
                show:false,
            },
            labelLine: {
                show: false
            },
            data: [
                { value: 1048, name: '苏宁' },
                { value: 735, name: '五星' },
                { value: 580, name: '超市' },
                { value: 484, name: '联盟' },
                { value: 300, name: '直营' },
                { value: 200, name: '其他' },
            ]
        },
        {
            name: '中间文字',
            z: 100,
            type: 'gauge',
            radius: '-50%',
            center: ['51%', '43%'],
            // 配置中间的数字的样式
            detail: {
                // 调节数字位置
                offsetCenter: [-1, -10],
                formatter:(params) => `${params}%`,
                fontSize: 28,
                fontFamily: 'D DIN',
                color: 'black',
        },
        pointer: {
            show: false,
        },
        axisTick: {
            show: false,
        },
        axisLine: {
            show: false,
        },
        splitLine: {
            show: false,
        },
        axisLabel: {
            show: false,
        },
        // 中间的字和数字 数据
        data: [
            {
                value: 27.50,
                name: '苏宁占比最高',
                title: {// 配置“家居总数”的样式
                    show: true,
                    fontSize: 12,
                    fontFamily: 'Microsoft YaHei',
                    color: 'rgba(0, 0, 0, 0.75)',
                    offsetCenter: [0, '-20%']
                },
            },

        ],
        },
    ]
};

const barTwoOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        top: '0%',
        right: '1%',
        bottom: '5%',
    },
    grid: {
        top: '22%',
        left: '0.5%',
        right: '2%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2024-8', '2024-9', '2424-10', '2024-11', '2024-12', '2025-1', '2025-2', '2025-3', '2025-4', '2025-5', '2025-6', '2025-7']
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '单位（万元）'
        }
    ],
    series: [
        {
            name: '逾期总额',
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: 'rgb(147, 113, 220)',
            },
            barWidth: '22',
            data: [20, 32, 10, 134, 90, 60, 170, 80, 290, 63, 79, 82]
        },
        {
            name: '本月新增',
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: 'rgb(82, 216, 169)',
            },
            barWidth: '22',
            data: [22, 118, 91, 34, 129, 33, 201, 53, 110, 29, 73, 10]
        },
    ]
};

const pieTwoOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        bottom: '-1%',
        data: ['坏账-准备', '坏账-计提','坏账-冲回',]
    },
    series: [
        {
            name: '组织占比',
            type: 'pie',
            radius: ['50%', '65%'],
            center: ['51%', '43%'],
            avoidLabelOverlap: false,
            itemStyle: {
                borderRadius: 4,
                borderColor: '#fff',
                borderWidth: 2
            },
            color: ['rgb(147, 113, 220)', 'pink', 'rgb(82, 216, 169)'],
            label: {
                show: false,
                position: 'center',
            },
            emphasis: {
                show:false,
            },
            labelLine: {
                show: false
            },
            data: [
                { value: 1048, name: '坏账-准备' },
                { value: 735, name: '坏账-计提' },
                { value: 580, name: '坏账-冲回' },
            ]
        },
                {
            name: '中间文字',
            z: 100,
            type: 'gauge',
            radius: '-50%',
            center: ['51%', '43%'],
            // 配置中间的数字的样式
            detail: {
                // 调节数字位置
                offsetCenter: [-1, -10],
                formatter:(params) => `${params}%`,
                fontSize: 28,
                fontFamily: 'D DIN',
                color: 'black',
        },
        pointer: {
            show: false,
        },
        axisTick: {
            show: false,
        },
        axisLine: {
            show: false,
        },
        splitLine: {
            show: false,
        },
        axisLabel: {
            show: false,
        },
        // 中间的字和数字 数据
        data: [
            {
                value: 56,
                name: '坏账-准备占比最高',
                title: {// 配置“家居总数”的样式
                    show: true,
                    fontSize: 12,
                    fontFamily: 'Microsoft YaHei',
                    color: 'rgba(0, 0, 0, 0.75)',
                    offsetCenter: [0, '-20%']
                },
            },

        ],
        },
    ]
};

const barThreeOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        top: '0%',
        right: '1%',
        bottom: '5%',
    },
    grid: {
        top: '22%',
        left: '0.5%',
        right: '2%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2024-8', '2024-9', '2424-10', '2024-11', '2024-12', '2025-1', '2025-2', '2025-3', '2025-4', '2025-5', '2025-6', '2025-7']
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '单位（天）'
        }
    ],
    series: [
        {
            name: '应收',
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: 'rgb(147, 153, 340)',
            },
            barWidth: '22',
            data: [60, 170, 80, 290, 63, 79, 20, 32, 10, 134, 90, 82]
        },
        {
            name: '逾期',
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: 'green',
            },
            barWidth: '22',
            data: [22, 201, 53, 110, 29, 73, 118, 91, 34, 129, 33, 10]
        },
        {
            name: '逾期率',
            type: 'line',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: 'orange',
            },
            barWidth: '22',
            data: [53, 110, 22, 118, 19, 34, 73, 210, 129, 33, 201, 29]
        },
    ]
};

const pieThreeOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        bottom: '-1%',
    },
    series: [
        {
            name: '逾期客户占比',
            type: 'pie',
            radius: '69%',
            avoidLabelOverlap: false,
            itemStyle: {
                borderRadius: 4,
                borderColor: '#fff',
                borderWidth: 2
            },
            color: ['gold', 'rgb(248, 242, 202)', 'orange'],
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: 40,
                    fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            data: [
                { value: 1048, name: '苏宁' },
                { value: 735, name: '五星' },
                { value: 580, name: '其他' },
            ]
        }
    ]
};

const drawChart = () => {
    const barOneChart = echarts.init(document.getElementById('barOne'));
    barOneChart.setOption(barOneOptions);
    const pieOnechart = echarts.init(document.getElementById('pieOne'));
    pieOnechart.setOption(pieOneOptions);

    const barTwoChart = echarts.init(document.getElementById('barTwo'));
    barTwoChart.setOption(barTwoOptions);
    const pieTwochart = echarts.init(document.getElementById('pieTwo'));
    pieTwochart.setOption(pieTwoOptions);

    const barThreeChart = echarts.init(document.getElementById('barThree'));
    barThreeChart.setOption(barThreeOptions);
    const pieThreechart = echarts.init(document.getElementById('pieThree'));
    pieThreechart.setOption(pieThreeOptions);
}

onMounted(() => {
    drawChart()
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.demo-container {
    width: calc(100% - 32px);
    font-family: 'Microsoft YaHei';
    height: 100%;
    font-size: 14px;
    padding: 16px;
}

img {
    width: 64px;
    height: 64px;
}

.demo-top {
    width: 100%;
    /* height: 25%; */
    display: flex;
    justify-content: space-between;
}

.demo-center {
    width: 100%;
    height: 36%;
}

.demo-top-card {
    width: 28.5%;
    height: 120px;
    background: white;
    border: 1px solid white;
    border-radius: 14px;
    padding: 16px 24px;
}

.demo-top-card-top {
    display: flex;
    justify-content: space-between;
}

.demo-top-card-title {
    text-align: left;
    font-weight: 600;
    margin-bottom: 12px;
}

.demo-center-title {
    float: left;
    text-align: left;
    font-weight: 600;
}

.demo-top-card-money {
    font-size: 30px;
    font-family: 'D DIN Bold';
    margin-right: 4px;
}

.demo-top-card-center {
    margin-top: 8px;
    color: rgba(0, 0, 0, 0.778);
    display: flex;
}

.demo-top-card-center-left {
    margin-right: 28px;
}

.to-bottom {
    display: inline-block;
    margin-bottom: 2px;
    width: 0;
    height: 0;
    border-top: 5px solid black;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
}

.to-top {
    display: inline-block;
    width: 0;
    height: 0;
    margin-bottom: 2px;
    border-bottom: 5px solid black;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
}

.demo-center {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
}

.demo-center-left {
    height: 272px;
    width: 69%;
    background: white;
    border: 1px solid white;
    border-radius: 14px;
    padding: 16px 24px;
}

.demo-center-left-chart {
    height: 100%;
}

.demo-center-right {
    height: 272px;
    width: 22%;
    background: white;
    border: 1px solid white;
    border-radius: 14px;
    padding: 16px 24px;
}
</style>
